import React, {CSSProperties, FC, memo, useEffect, useState} from "react";
import ContextMenu from "../ContextMenu/ContextMenu";
import {CardContainer, CardContext, CardContextImg, CardText} from "./CardStyle";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import FileCheckbox from "../FileCheckbox/FileCheckbox";
import {actions as actionsFiles, IFile} from "../../store/sliceFiles";
import {actions as modal} from "../../store/sliceModal";
import {useNavigate} from "react-router-dom";
import fileIcon from "../../image/file.png"
import pdfIcon from "../../image/pdf.png"
import wordIcon from "../../image/word.png"
import videoIcon from "../../image/video.png"
import archiveIcon from "../../image/archive.png"
import musicIcon from "../../image/music.png"
import {maxContent} from "../../utils/Util";


export type CardProps = {
    file: IFile
    style?: CSSProperties | undefined;
    checkMode: boolean
    publicPath?: string
}

const CardDefault: FC<CardProps> = (props) => {

    const {file, checkMode, publicPath} = props
    const dispatch = useDispatch<AppDispatch>();
    const audio = ['mp3', 'mpeg', 'wav', 'wave', 'flac', 'ape', 'aac', 'wma', 'ogg'];
    const video = ['mov', 'mkv', 'avi', 'mpeg-4', 'mp4', 'wmv', 'flv'];
    const nav = useNavigate();

    const [checked, setChecked] = useState(false)
    const [img, setImg] = useState('')

    useEffect(() => {
        setChecked(false);
    }, [checkMode])

    useEffect(() => {
        if (!!file && ['pdf', 'xpdf'].includes(file?.type?.toLowerCase())) {
            setImg(pdfIcon)
        } else if (!!file && ['doc', 'docx' ].includes(file?.type?.toLowerCase())) {
            setImg(wordIcon)
        } else if (!!file && video.includes(file?.type?.toLowerCase())) {
            setImg(videoIcon)
        } else if (!!file && ['rar', 'zip'].includes(file?.type?.toLowerCase())) {
            setImg(archiveIcon)
        } else if (!!file && audio.includes(file?.type?.toLowerCase())) {
            setImg(musicIcon)
        } else {
            setImg(fileIcon)
        }

    }, [file])

    const showModal = (event: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) => {

        if (checkMode) {
            if (checked) {
                dispatch(actionsFiles.removeChecked(file?.id!!))
                setChecked(false)
            } else {
                dispatch(actionsFiles.addChecked(file?.id!!))
                setChecked(true)
            }
        } else if (file!! && audio.includes(file.type)){
            dispatch(modal.showMediaModal({file: file, isAudio: true}))
        } else if (file!! && video.includes(file.type)){
            dispatch(modal.showMediaModal({file: file, isAudio: false}))
        }
    }


    return (
        <CardContainer cheked={checkMode}
                       onClick={showModal}
        >
            <CardContext>
                <ContextMenu file={file} isPublic={publicPath?.length != null}>
                    <CardContextImg image={img}>
                        {checkMode &&
                            <FileCheckbox cheked={checked}/>
                        }
                    </CardContextImg>
                </ContextMenu>
            </CardContext>
            <CardText>{`${maxContent(file?.name)}.${file?.type}`}</CardText>
        </CardContainer>
    )

}

export default memo(CardDefault)
